<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="标签组名称">
              <a-input
                placeholder="请输入标签组名称"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="标签类型">
              <a-select v-model="queryParam.type" placeholder="请选择标签类型">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="1">群</a-select-option>
                <a-select-option value="2">渠道</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新建分组</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">
            <a-icon type="delete" @click="batchDel" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        childrenColumnName="tag"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="r => r.id"
        @change="handleTableChange"
      >
        <template slot="tags" slot-scope="text, record">
          <a-tag color="blue" v-for="item in record.tags" :key="item.id">
            {{ item.name }}
          </a-tag>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <system-tag-modal ref="modalForm" @ok="modalFormOk"></system-tag-modal>
  </a-card>
</template>

<script>
import { postAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import systemTagModal from './systemTagModal';
import moment from 'moment';
import TagModal from './TagModal';

export default {
  name: 'tagList',
  mixins: [JeecgListMixin],
  components: {
    systemTagModal,
    TagModal
  },
  data() {
    return {
      columns: [
        {
          title: '标签组名称',
          align: 'left',
          dataIndex: 'name'
        },
        {
          title: '标签',
          align: 'left',
          dataIndex: 'tags',
          ellipsis: true,
          scopedSlots: { customRender: 'tags' }
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sort'
        },
        {
          title: '标签类型',
          align: 'center',
          dataIndex: 'type',
          customRender: function(text) {
            if (text == 1) {
              return '群';
            } else if (text == 2) {
              return '渠道';
            }
            // else {
            //   return '话术'
            // }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 170
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tagmanage/queryGroupTag',
        delete:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tagmanage/deleteTag',
        deleteBatch:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tagmanage/deleteBatch'
      }
    };
  },
  methods: {
    handleDelete(tagIds) {
      const that = this;
      postAction(this.url.delete, {
        id: tagIds
      })
        .then(res => {
          if (res.success) {
            that.$message.success(res.message);
            that.$emit('ok');
          } else {
            that.$message.warn(res.message);
            that.$emit('error');
          }
        })
        .finally(() => {
          that.loadData();
        });
    },
    handleMenuClick(e) {
      if (e.key === '1') {
        this.batchDel();
      }
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
